var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCounterNotificationQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005993",
    d: "M26 0C11.663 0 0 11.663 0 26s11.663 26 26 26 26-11.663 26-26S40.337 0 26 0zm0 41.166a2.167 2.167 0 1 1 .001-4.334A2.167 2.167 0 0 1 26 41.166zm3.43-13.775a2.176 2.176 0 0 0-1.264 1.97v.973a2.166 2.166 0 1 1-4.332 0v-.973a6.528 6.528 0 0 1 3.78-5.907c2.208-1.016 3.802-3.714 3.802-5.038A5.423 5.423 0 0 0 26 13a5.423 5.423 0 0 0-5.416 5.416 2.166 2.166 0 1 1-4.334 0c0-5.375 4.374-9.75 9.75-9.75s9.75 4.375 9.75 9.75c0 2.928-2.54 7.23-6.32 8.975z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCounterNotificationQuestion);
export default __webpack_public_path__ + "static/media/ic_counter_notification_question.4cfa6e656126474f9476a430cd052a09.svg";
export { ForwardRef as ReactComponent };